import { AfterContentChecked, Directive, ElementRef, inject } from '@angular/core';

/**
 * this directive ensures elements with the ig-focus class really have the focus
 */

@Directive({
  standalone: true,
  selector: '[igAutocompleteOverlayFocus]'
})
export class AutocompleteOverlayFocusDirective implements AfterContentChecked {
  #el = inject(ElementRef);


  ngAfterContentChecked() {
    if ((this.#el.nativeElement as HTMLElement).classList.contains('ig-focus')) {
      this.#el.nativeElement.focus();
    }
  }

}
